import { AGGREGATE_NAMES, TEMPLATE_RESOLVERS } from 'cpool-constants';
import { schemaTemplateResolver_GetOwnMailHeaderFooter } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';

export const useOwnMailHeaderFooter = () =>
    useAggregateQuery({
        acl: {},
        aggregateName: AGGREGATE_NAMES.TEMPLATE,
        resolverName: TEMPLATE_RESOLVERS.getOwnMailHeaderFooter,
        schema: schemaTemplateResolver_GetOwnMailHeaderFooter,
    });
